import React from 'react';
import Modal from 'react-bootstrap/Modal';
import API from 'API';
import Print from 'Print';

import Loader from 'components/common/Loader';

//-----------------------------------------------------------------

class MailMergeModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            doNotClean: false,
            reason: null
        };
    }

    open(opt) {
        return new Promise((resolve) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                customerIDs: opt.customerIDs,
                letterTemplateID: null,
                isLoading: true
            });
            this.load();
        });
    }

    async load() {
        this.setState({ isLoading: true });
        const letterTemplates = await API.call('letter/list-templates');
        this.setState({
            isLoading: false,
            letterTemplates
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async create(isInline) {
        const { letterTemplateID, customerIDs } = this.state;
        const cookieName = 'mailMergeCustomerIDs';
        this.setState({ isLoading: true });
        if (customerIDs) {
            const val = encodeURIComponent(JSON.stringify(customerIDs));
            document.cookie = `${cookieName}=${val}; path=/;`;
        }
        Print.url('/api/letter/merge-customers', {
            letterTemplateID,
            isInline
        });

        // After initiating the print/download, wait until the temporary cookie is removed.
        await new Promise(resolve => {
            const timer = setInterval(() => {
                if (!document.cookie.split(';').some(c => c.trim().startsWith(`${cookieName}=`))) {
                    clearInterval(timer);
                    clearTimeout(timeout);
                    resolve();
                }
            }, 500);
            const timeout = setTimeout(() => {
                clearInterval(timer);
                resolve();
            }, 120000);
        });

        this.setState({ isLoading: false });
        return;
    }

    render() {
        const {
            isOpen,
            isLoading,
            letterTemplateID
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show onHide={() => this.close()} className="mail-merge-modal" backdrop="static">
                <form onSubmit={e => { e.stopPropagation(); e.preventDefault(); this.saveAndClose() }}>
                    <Modal.Body>
                        
                        {this.renderInner()}

                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => this.close()}>
                            Cancel
                        </button>
                        <div className="ms-auto">
                            {!!letterTemplateID && !isLoading && <>
                                <button type="button" className="btn btn-primary me-3" onClick={() => this.create(false)}>
                                    Download
                                </button>
                                <button type="button" className="btn btn-primary" onClick={() => this.create(true)}>
                                    Print
                                </button>
                            </>}
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>
        );
    }

    renderInner() {
        const { isLoading, letterTemplateID, letterTemplates, customerIDs } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>
            <div className="form-group mb-gutter">
                <label className="form-label">Number of Customers</label>
                <p className="form-control-plaintext">
                    {customerIDs.length}
                </p>
            </div>

            <div className="form-group mb-0">
                <label className="form-label">Letter Template</label>
                <select
                    className="form-control"
                    value={letterTemplateID || ''}
                    onChange={e => this.setState({ letterTemplateID: e.target.value })}
                >
                    <option value="">(Select)</option>
                    {letterTemplates.map(lt =>
                        <option key={lt.id} value={lt.id}>
                            {lt.name}
                        </option>
                    )}
                </select>
            </div>



        </>);
    }
}

export default MailMergeModal;